// extracted by mini-css-extract-plugin
export default {"notificationsPage":"NotificationsPage_notificationsPage__prqa7","notificationGrid":"NotificationsPage_notificationGrid__LvKyW","notification":"NotificationsPage_notification__mbbhP"};